var map = {
	"./1.png": "2f21",
	"./2.png": "8c32",
	"./3.png": "ab7e",
	"./down.png": "abb6",
	"./the sun evolution 1-01.png": "2242",
	"./the sun evolution 2-01.png": "0699",
	"./the sun evolution 3-01.png": "ecf8",
	"./the sun evolution 4-01.png": "a53a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a57c";